<div class="attachment-menu">
  <div class="attachment-header">{{ menuTitle ? menuTitle : ('attachmentMenu_add_an_attachment' | xsI18n) }}</div>
  <ul class="attachment-list">
    <li
      class="nowrap attachment-item"
      (click)="onSelectedAttachment(attachment)"
      *ngFor="let attachment of attachmentList"
    >
      <a sa-ellipsis append-to-body="true" [fullText]="attachment.details.fileName" class="ng-scope">{{
        attachment.fileName
      }}</a>
    </li>
    <div class="no-attachments" *ngIf="isAttachmentListEmpty()">{{ 'attachmentMenu_no_attachment' | xsI18n }}</div>
  </ul>
  <div class="attachment-footer-button">

    <input type="file" class="file-input"
           [accept]="fileSelectionType"
           (change)="onSelectedFile($event)"
           #fileUpload
    />

    <button
      type="file"
      class="xs-btn btn-primary"
      (click)="fileUpload.click()"
     >
      {{ 'attachmentMenu_browse' | xsI18n }}
    </button>
<!--      [select]="onSelectedFile({ file: $file, invalidFiles: $invalidFiles }, null)"-->
<!--      [maxSize]="maxAttachmentSize + 'MB'"-->
<!--      [accept]="'fileSelectionType'"-->

  </div>
</div>
